import RegisterFiscalRegimeError from './RegisterFiscalRegimeError';
class InvalidFiscalRegime extends RegisterFiscalRegimeError {
    constructor(options) {
        super('Investor is trying to add an invalid fiscal regime', options);
    }
}
export default InvalidFiscalRegime;
